exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title_class_registration[data-v-20a1910f]{display:block!important;flex-direction:row!important;text-align:-webkit-center!important}.package_li[data-v-20a1910f]{padding:10px;text-align:center;background:grey;margin-bottom:8px;margin-top:8px;color:#000}", ""]);

// exports
